// src/pages/PrivacyPolicy.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Ziyarat Guide</title>
        <meta
          name="description"
          content="Read Ziyarat Guide’s privacy policy to understand how we collect, use, and protect your personal data while ensuring transparency and security."
        />
        <meta property="og:title" content="Privacy Policy | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Learn how Ziyarat Guide safeguards your information, manages cookies, and respects your data privacy across our website and services."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="page-container">
        <h1 className="page-title">Privacy Policy</h1>

        <p>
          At Ziyarat Guide, your privacy is important to us. This Privacy Policy
          explains how we collect, use, and protect your personal information
          when you visit our website or interact with our services.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>
            <strong>Personal Information:</strong> Your name, email address, or
            other contact information you provide through contact forms or
            newsletter subscriptions.
          </li>
          <li>
            <strong>Usage Data:</strong> Information automatically collected
            when you browse our website, such as IP addresses, browser type,
            pages visited, and access times.
          </li>
          <li>
            <strong>Cookies:</strong> Small files stored on your device to help
            improve user experience and website functionality.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>
            To respond to inquiries, messages, or requests submitted through our
            contact forms.
          </li>
          <li>
            To improve and personalize the content, features, and functionality
            of our website.
          </li>
          <li>
            To send occasional updates, newsletters, or announcements if you
            have opted in.
          </li>
          <li>
            To analyze website usage trends and ensure smooth operation of our
            services.
          </li>
        </ul>

        <h2>3. Sharing Your Information</h2>
        <p>
          We do not sell, trade, or otherwise transfer your personal information
          to outside parties except as described below:
        </p>
        <ul>
          <li>
            Trusted third-party service providers who assist us in operating our
            website or services (e.g., hosting providers, analytics tools), under
            strict confidentiality agreements.
          </li>
          <li>
            When required by law, legal processes, or to protect our rights,
            safety, or property.
          </li>
        </ul>

        <h2>4. Data Security</h2>
        <p>
          We implement reasonable administrative, technical, and physical
          safeguards to protect your personal information. However, no method of
          transmission over the Internet or electronic storage is 100% secure.
        </p>

        <h2>5. Your Rights</h2>
        <ul>
          <li>
            You can request access to, correction, or deletion of your personal
            information.
          </li>
          <li>
            You may unsubscribe from newsletters or promotional communications
            at any time.
          </li>
          <li>
            You can disable cookies through your browser settings, though some
            features may be affected.
          </li>
        </ul>

        <h2>6. Third-Party Links</h2>
        <p>
          Our website may contain links to external websites. We are not
          responsible for the privacy practices or content of these third-party
          sites.
        </p>

        <h2>7. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The latest
          version will always be posted on this page with the effective date.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or your personal
          data, please contact us at{' '}
          <a href="mailto:info@ziyaratguide.com">info@ziyaratguide.com</a>.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
